// extracted by extract-css-chunks-webpack-plugin
module.exports = {"imageAnim":"Tl946","fadeinout":"ZmAkI","loader":"XRkjT"};